module.exports = __webpack_public_path__ + "img/capturaPantalla.adbd8d33.png";